import React, { useState, useEffect } from 'react';
import { settingsApi } from '../services/api';

function WebsiteSettings() {
  const [isSet, setIsSet] = useState(null);
  const [loadError, setLoadError] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [removing, setRemoving] = useState(false);
  const [formError, setFormError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    settingsApi
      .getWebsitePasswordSet()
      .then((res) => setIsSet(res.data.is_set))
      .catch(() => setLoadError('Fehler beim Laden des Status.'));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError('');
    setSuccessMsg('');

    if (password.length < 4) {
      setFormError('Passwort muss mindestens 4 Zeichen haben.');
      return;
    }
    if (password !== confirm) {
      setFormError('Passwörter stimmen nicht überein.');
      return;
    }

    setSaving(true);
    try {
      await settingsApi.setWebsitePassword(password);
      setSuccessMsg('Website-Passwort erfolgreich gesetzt.');
      setIsSet(true);
      setPassword('');
      setConfirm('');
    } catch (err) {
      const msg = err.response?.data?.message || 'Fehler beim Speichern.';
      setFormError(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-container">
      <h1>Einstellungen</h1>

      <section className="settings-section" aria-labelledby="website-pw-heading">
        <h2 id="website-pw-heading">Website-Passwort (Beta-Zugang)</h2>

        {loadError && (
          <p role="alert" className="error-message">
            {loadError}
          </p>
        )}

        {isSet !== null && (
          <p className="status-badge">
            Status:{' '}
            <strong>
              {isSet ? 'Passwort gesetzt ✓' : 'Kein Passwort gesetzt'}
            </strong>
          </p>
        )}

        <form
          onSubmit={handleSubmit}
          noValidate
          aria-label="Website-Passwort setzen"
          style={{ marginTop: '1.25rem', maxWidth: '420px' }}
        >
          <div className="form-group">
            <label htmlFor="ws-password">
              Neues Passwort
            </label>
            <input
              id="ws-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              aria-describedby={formError ? 'ws-form-error' : undefined}
              aria-invalid={formError ? 'true' : 'false'}
              disabled={saving}
              required
              minLength={4}
            />
          </div>

          <div className="form-group">
            <label htmlFor="ws-confirm">
              Passwort bestätigen
            </label>
            <input
              id="ws-confirm"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoComplete="new-password"
              aria-invalid={formError ? 'true' : 'false'}
              disabled={saving}
              required
            />
          </div>

          {formError && (
            <p id="ws-form-error" role="alert" className="error-message">
              {formError}
            </p>
          )}

          {successMsg && (
            <p role="status" className="success-message">
              {successMsg}
            </p>
          )}

          <button
            type="submit"
            className="btn btn-primary"
            disabled={saving || !password || !confirm}
            aria-busy={saving}
          >
            {saving ? 'Speichern…' : isSet ? 'Passwort ändern' : 'Passwort setzen'}
          </button>
        </form>

        {isSet && (
          <div style={{ marginTop: '1.5rem' }}>
            <h3>Passwort entfernen</h3>
            <p style={{ color: '#888', fontSize: '0.875rem' }}>
              Entfernt den Passwortschutz — die Website ist dann ohne Passwort zugänglich.
            </p>
            <button
              type="button"
              className="btn btn-danger"
              disabled={removing}
              aria-busy={removing}
              onClick={async () => {
                if (!window.confirm('Passwort wirklich entfernen?')) return;
                setRemoving(true);
                setFormError('');
                setSuccessMsg('');
                try {
                  await settingsApi.deleteWebsitePassword();
                  setIsSet(false);
                  setSuccessMsg('Passwort entfernt — Gate deaktiviert.');
                } catch {
                  setFormError('Fehler beim Entfernen des Passworts.');
                } finally {
                  setRemoving(false);
                }
              }}
            >
              {removing ? 'Entfernen…' : 'Passwortschutz deaktivieren'}
            </button>
          </div>
        )}
      </section>
    </div>
  );
}

export default WebsiteSettings;
